"use strict";

import { Time } from "../../systems/core/time.js";
import { UIContainer } from "../uiContainer.js";
import { UISprite } from "../uiSprite.js";
import { UIButton } from "./uiButton.js";
import { UIText } from "../uiText.js";
import { Coroutine } from "../../systems/secondary/coroutine.js";

export class UIPicker extends UIContainer {
    constructor(config) {
        let _onInitialize = config.onInitialize;
        config.onInitialize = undefined;

        super(config);

        let fontsProperties = {
            value: {
                fontFamily: "Arial",
                fontSize: 17,
                align: "center",
                fill: "white"
            }
        };

        this.previous = config.previousButton;
        this.previous.setParent(this);
        this.previous.registerEvent("down", () => {
            let previousIndex = this.selectedIndex - 1;
            if (previousIndex >= 0) {
                this.select(previousIndex);
            }
        });

        this.next = config.nextButton;
        this.next.setParent(this);
        this.next.registerEvent("down", () => {
            let nextIndex = this.selectedIndex + 1;
            if (nextIndex >= this.valueCount) return;
            this.select(nextIndex);
        });

        this.values = config.values;
        this.valueCount = this.values.length;

        this.valueWidth = config.valueWidth;
        this.valueHeight = config.valueArea.size.height;
        this.spacing = config.spacing ?? 1;

        this.valueContainer = new UIContainer({
            rect: config.valueArea,
            parent: this
        });
        this.valueMask = new UISprite({
            textureID: "Empty",
            rect: {
                size: {...this.valueContainer.calculatedRect.size}
            },
            parent: this
        });
        this.valueContainer.mask = this.valueMask;
        // this.valueMask.alpha = 0.3;

        this.valueObjects = [];

        let valueBoundsFrom = this.valueContainer.calculatedRect.center.x -
            this.valueContainer.calculatedRect.size.width / 2;
        let stepX = valueBoundsFrom + this.valueWidth / 2;
        for (let i = 0; i < this.valueCount; i++) {
            let object = new UIButton({
                id: i,
                graphics: new UISprite({
                    textureID: "UI_PickerValue"
                }),
                rect: {
                    position: {
                        x: stepX + (this.valueWidth + this.spacing) * i,
                        y: 0
                    }
                },
                parent: this.valueContainer,
                onPointerDown: id => this.select(id)
            });
            object.label = new UIText({
                text: this.values[i].toString(),
                fontProperties: fontsProperties.value,
                parent: object
            });
            this.valueObjects.push(object);
        }
        
        this.indicator = new UISprite({
            textureID: "UI_PickerIndicator",
            parent: this.valueContainer
        });

        this.selectedIndex = config.selected ?? 0;
        this.selectSpeed = config.selectSpeed ?? 10;
        this.select(this.selectedIndex);

        this.onSelected = config.onSelected;

        _onInitialize?.bind(this)(config);
        this.updateNow();
    }

    select(index) {
        let prevIndex = this.selectedIndex;
        this.selectedIndex = index;
        this._validateValueVisibility();

        Coroutine.start(new Coroutine(this._select(prevIndex, index)));

        this.onSelected?.(this.selectedIndex);
    }
    *_select(from,to) {
        let delta = 0;
        while (delta < 1) {
            delta = Math.min(delta + Time.deltaTime * this.selectSpeed, 1);
            this.indicator.rect.position.x = this.transformFromUI(
                Math.lerp(this.valueObjects[from].x,
                this.valueObjects[to].x, delta)
            );
            this.indicator.updateNow();
            yield null;
        }
    }
    _validateValueVisibility() {
        let x = this.valueObjects[this.selectedIndex].x;
        let min = this.transformFromUI(x - this.valueWidth / 2);
        let max = this.transformFromUI(x + this.valueWidth / 2);

        let startX = this.valueContainer.calculatedRect.center.x -
            this.valueContainer.calculatedRect.size.width / 2;
        let endX = this.valueContainer.calculatedRect.center.x +
            this.valueContainer.calculatedRect.size.width / 2;

        if (min < startX) {
            // Reveal from the left
            this._moveObjectTo(this.selectedIndex, startX + this.valueWidth / 2);
        } else if (max > endX) {
            // Reveal from the right
            this._moveObjectTo(this.selectedIndex, endX - this.valueWidth / 2);
        }
    }
    _moveObjectTo(index,x) {
        let stepX = x - (this.valueWidth + this.spacing) * index;
        for (let i = 0; i < this.valueCount; i++) {
            this.valueObjects[i].rect.position.x = stepX + (this.valueWidth + this.spacing) * i;
            this.valueObjects[i].updateNow();
        }
    }
}